import { FileIgnoreRules } from "../files/ignore.js";
/**
 * Abstract FileTree for all environments (Deno, Browser, Python)
 */ export class FileTree {
  // Relative path to this FileTree location
  path;
  // Name of this directory level
  name;
  files;
  directories;
  viewed;
  parent;
  #ignore;
  constructor(path, name, parent, ignore){
    this.path = path;
    this.files = [];
    this.directories = [];
    this.name = name;
    this.parent = parent;
    this.viewed = false;
    this.#ignore = ignore ?? new FileIgnoreRules([]);
  }
  get ignored() {
    if (!this.parent) return false;
    return this.#ignore.test(this.path);
  }
  _get(parts) {
    if (parts.length === 0) {
      return undefined;
    } else if (parts.length === 1) {
      return this.files.find((x)=>x.name === parts[0]) || this.directories.find((x)=>x.name === parts[0]);
    } else {
      const nextDir = this.directories.find((x)=>x.name === parts[0]);
      return nextDir?._get(parts.slice(1, parts.length));
    }
  }
  get(path) {
    if (path.startsWith('/')) {
      path = path.slice(1);
    }
    return this._get(path.split('/'));
  }
  contains(parts) {
    const value = this._get(parts);
    return value ? value.viewed = true : false;
  }
}
//# sourceMappingURL=filetree.js.map